//import './style/mo.scss' ;
import './style/mo-keknap.scss' ;

import React from 'react'
import ReactDOM from "react-dom/client"

import thunk from "redux-thunk";
import { createStore, applyMiddleware, compose } from "redux";
import { createBrowserRouter, RouterProvider, Route, } from "react-router-dom";

// TODO: 
// import { createBrowserHistory } from "history";
// import history from "./util/history";

import rootReducer from "./state/rootReducer";
import { fetchViewport, applyUrlParams } from './state/viewportActions.js';
import {SET_API_URLS, TOGGLE_MENU_VISIBILITY, fetchGeoJson, SET_MAP_STYLE } from './state/uiActions' // TOGGLE_INFO_VISIBILITY
import {SET_EXTRA_MAP_FEATURES, SET_EXTRA_MAP_FEATURES_VISIBILITY} from './state/viewportActions.js' ;

import {isAppInIframe} from './util/mediatype.js'
import App from './App'
import extraMapFeatures from 'extraMapFeatures' ;

//import { playScenario } from './playback/playbackControllerAnimationFrameSimple';
//import { playScenario } from './playback/playbackControllerAnimationFrame';

// https://github.com/mapbox/mapbox-gl-js/issues/1800 - missing tileset error hack
var consoleerror = console.error;
console.error = function (err) {
    if (typeof (err.stack) != 'undefined' && err.stack.includes('at Actor.receive (https://api.tiles.mapbox.com/')) {
        return;
    } else {
        consoleerror(err);
    }
}

const middleware = [ thunk ];
const store = createStore(
    rootReducer,
    // redux devtools required a hack of compose - removed, not used
    compose( applyMiddleware(...middleware) ) 
);

// URL paramteres:
var url = new URL(window.location.href);
var show = url.searchParams.get("show");
var download = url.searchParams.get("download");
const path = url.pathname ; //window.location.pathname ;
// subview: set to null when empty ("")
var subview = path.split( '/' )[2]
if (subview=="") subview = null 
console.log("subview: ", subview)

//ReactDOM.createRoot( document.getElementById("root")).render(
//  <React.StrictMode>
//    <RouterProvider router={router} />
//  </React.StrictMode>
//);

ReactDOM.createRoot( document.getElementById("root")).render(
  <React.StrictMode>
      <App store={store} 
        // afterMapInitialization={afterMapInitialization}
        basename={BASENAME} 
        // TODO: 
        // navigate={navigate}
        initialSubview={subview}
      />
  </React.StrictMode>
);

//render(
//  <Provider store={store}>
//    <DisplayTimeOverlay/>,
//  </Provider>,
//  document.getElementById('timerOverlay')
//);

store.dispatch( {type: SET_API_URLS, apiURL: MO_API_URL, jsonURL: JSON_URL})

// set default visibility of layer items: 
// set only one visible when subview is defined
var visibilities = {}
extraMapFeatures.items.map( (item, index) => {
  var visible = JSON.parse(item.visible) ; 

  if (subview)  {
    visible = false ;
    if (item.key == subview) {
      visible = true ;
    }
  }
  visibilities[item.key] = visible
  if (visible) {
    if (item.lineGeoJsonUrl) {
      store.dispatch( fetchGeoJson(item.key, item.lineGeoJsonUrl) )
      // .then( () => { });  
    }
  }
} )

store.dispatch( {type: SET_EXTRA_MAP_FEATURES, features: extraMapFeatures }) ;

store.dispatch( {type: SET_EXTRA_MAP_FEATURES_VISIBILITY, visibilities: visibilities}) ;  

// fetchViewport action creator returns function returning a promise
store.dispatch( fetchViewport( VIEWPORT_ID, subview, true ) )
.then( () => {
  //console.log("viewport fetched")
  store.dispatch( applyUrlParams(show) ) ;

});


if ((! MENU_VISIBLE ) || isAppInIframe() )  {
  store.dispatch({ type: TOGGLE_MENU_VISIBILITY })
}

if (subview) {
  store.dispatch({ type: SET_MAP_STYLE, mapStyle: MAP_SUBVIEW_STYLE})
}

